import { useEffect, useRef } from "react";
import { cn } from "@/lib/utils";

// Responsive Google AdSense unit. Reserves space (min-heights) to avoid layout
// shift (CLS). The adsbygoogle.js loader is included in public/index.html <head>.
const AD_CLIENT = "ca-pub-5137361565089631";
const AD_SLOT = "2554465978";

const SIZES = {
  horizontal: "min-h-[100px] sm:min-h-[120px] lg:min-h-[160px]",
  rectangle: "min-h-[250px] sm:min-h-[280px]",
  sidebar: "min-h-[600px]",
};

export const AdPlaceholder = ({ format = "horizontal", label = "Advertisement", slot = "", className = "" }) => {
  const sticky = format === "sidebar";
  const pushed = useRef(false);

  useEffect(() => {
    if (pushed.current) return;
    pushed.current = true;
    try {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    } catch (e) {
      // adsbygoogle loader not ready (e.g. blocked/offline preview) — ignore
    }
  }, []);

  return (
    <aside
      data-testid={`ad-${slot || format}`}
      data-ad-slot-name={slot}
      data-ad-format={format}
      aria-label="Advertisement"
      className={cn("w-full", sticky && "lg:sticky lg:top-24", className)}
    >
      <div
        className={cn(
          "relative w-full overflow-hidden rounded-2xl border border-dashed border-white/15 bg-white/[0.02]",
          SIZES[format] || SIZES.horizontal
        )}
      >
        <span className="absolute left-3 top-2 z-10 text-[10px] uppercase tracking-[0.2em] text-zinc-600">{label}</span>
        <ins
          className="adsbygoogle"
          style={{ display: "block", width: "100%" }}
          data-ad-client={AD_CLIENT}
          data-ad-slot={AD_SLOT}
          data-ad-format="auto"
          data-full-width-responsive="true"
        />
      </div>
    </aside>
  );
};

export default AdPlaceholder;
